import {Component, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {PreorderType} from 'src/smoothr-web-app-core/enums/PreorderType';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import {sleep} from 'src/smoothr-web-app-core/utils/utils';

@Component({
	selector: 'app-show-venue-in-map',
	templateUrl: './show-venue-in-map.component.html',
	styleUrls: ['./show-venue-in-map.component.scss']
})
export class ShowVenueInMapComponent implements OnInit {
	venue: Venue;
	constructor(private modalCtrl: ModalController) {}
	static async show(modalCtrl: ModalController, venue: Venue): Promise<{venue: Venue; preorderType: PreorderType}> {
		console.log(venue);
		const modal = await modalCtrl.create({
			component: ShowVenueInMapComponent,
			cssClass: 'show-venue',
			componentProps: {
				venue: venue
			}
		});
		await modal.present();
		const result = await modal.onDidDismiss();
		await sleep(100);
		return result.data;
	}
	ngOnInit() {}
	setupMap() {}
	selectVenue(venue: Venue, preorderType: PreorderType) {
		console.log(venue, preorderType);
		this.modalCtrl.dismiss({venue, preorderType});
	}
	dismiss() {
		this.modalCtrl.dismiss();
	}
}
